import { render, staticRenderFns } from "./SyncNewFacebookPageModal.vue?vue&type=template&id=52389404&scoped=true&"
import script from "./SyncNewFacebookPageModal.vue?vue&type=script&lang=ts&"
export * from "./SyncNewFacebookPageModal.vue?vue&type=script&lang=ts&"
import style0 from "./SyncNewFacebookPageModal.vue?vue&type=style&index=0&id=52389404&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52389404",
  null
  
)

export default component.exports